import moment from 'moment';

import { getMomentLocale } from 'ha/i18n';
import { setCookie } from 'ha/modules/Cookies';
import CookiesConstants from 'ha/constants/Cookies';

import { fetchUser } from './actions';
import { getIsLoaded, getIsAdmin } from '../selectors';

export default function initSession({ store, lang }) {
  moment.locale(getMomentLocale(lang));

  const isLoaded = getIsLoaded(store.getState())
    ? Promise.resolve()
    : store.dispatch(fetchUser());

  return isLoaded.then(() => {
    if (getIsAdmin(store.getState())) {
      store.dispatch(
        setCookie(CookiesConstants.PWA_NEXT_ENABLED, 1, {
          // Server lib doesn't support numbers as expires value
          expires: new Date(new Date() * 1 + 30 * 864e5),
        }),
      );
    }
  });
}
